import { render, staticRenderFns } from "./test-items.vue?vue&type=template&id=1181f0d9&scoped=true&"
import script from "./test-items.vue?vue&type=script&lang=ts&"
export * from "./test-items.vue?vue&type=script&lang=ts&"
import style0 from "./test-items.vue?vue&type=style&index=0&id=1181f0d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181f0d9",
  null
  
)

export default component.exports